// extracted by mini-css-extract-plugin
export default {"top_sec":"style_top_sec__gl1vz","item":"style_item__pUqiB"};